import loadable from '../../utilities/loadable'

export const YoutubeEmbed = loadable(() => import('./YoutubeEmbed'))
export const FeatureDemoPage = loadable(() =>
  import('./FeatureDemo/FeatureDemoPage')
)
export const FeatureVideoDetails = loadable(() =>
  import('./FeatureVideoDetails/FeatureVideoDetails')
)
